export default __webpack_public_path__ + "static/p0-f062aa193335979330ddec901f5a0b4a.png";